import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ContactCreditListItem = ResultOf<
  typeof contactCreditListQuery
>["contactCredits"]["data"][number];

export const contactCreditListQuery = graphql(`
  query ContactCreditList(
    $first: Int!
    $page: Int
    $contactId: ID
    $type: [ContactCreditType!]
    $currency: [Currency!]
    $orderBy: [QueryContactCreditsOrderByOrderByClause!]
  ) {
    contactCredits(
      first: $first
      page: $page
      contact_id: $contactId
      type: $type
      currency: $currency
      orderBy: $orderBy
    ) {
      data {
        id
        reference
        type
        currency
        amount
        description
        attributed_to_id
        attributed_to_type
        attributedTo {
          __typename
          ... on Booking {
            id
            reference
          }
        }
        invoicePayment {
          id
          invoice {
            id
            reference
          }
        }
        reversal {
          id
          reference
        }
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
